<template>
  <div>
    <PageTitle>
      <b-container>
        <h1 class="display-3">Edit project information</h1>
        <p class="lead">
          Update fields on the form below to edit a project. <br />
          Click submit to confirm any changes.
        </p>
        <b-button
          variant="primary"
          href="/SINSW CBA Tool Input Template.xlsm"
          download
        >
          Download inputs template
        </b-button>
      </b-container>
    </PageTitle>
    <b-overlay :show="loading" rounded="sm" no-wrap fixed />
    <b-container>
      <ProjectForm
        :data="project"
        :require_password="false"
        @onSubmit="submit($event)"
      />
    </b-container>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import ProjectForm from "@/components/ProjectForm.vue";

export default {
  name: "ProjectEdit",
  components: { PageTitle, ProjectForm },
  props: {},
  data() {
    return {
      error: false,
      loading: false,
      project: {},
    };
  },
  methods: {
    get_project() {
      this.loading = true;
      this.$store
        .dispatch("get", {
          url: "/project/" + this.$route.params.id,
        })
        .then((response) => {
          this.loading = false;
          this.project = response.data.data;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit(event) {
      this.loading = true;
      this.error = false;
      console.log(event);
      if (event.password == event.confirm_password) {
        this.$store
          .dispatch("post", {
            data: event,
            url: "/project/edit/" + this.$route.params.id,
          })
          .then((response) => {
            this.loading = false;
            this.$router.push({
              name: "ProjectList",
              params: {
                id: response.data.public_id,
              },
            });
          })
          .catch((error) => {
            this.loading = false;
            console.log(error.response.data);
          });
      } else {
        console.log("Passwords should match");
        this.error = true;
        this.loading = false;
      }
    },
  },
  mounted() {
    this.get_project();
    if (!this.isAdmin) {
      this.$router.push({ name: "logout" });
    }
  },
  created() {},
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
};
</script>
